(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function() {
  var html = document.documentElement;
  var body = document.body;
  var wrapper = null;
  var collectionHeader = null;
  var scrollTop = 0;
  var locked = false;
  var stickyTopRaf = 0;
  var stickyTopTimer = 0;
  var headerObserversReady = false;

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function isSortOpen() {
    return wrapper && wrapper.classList.contains('is--opened') && isMobile();
  }

  function lockScroll() {
    if (locked) return;
    scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    html.classList.add('t4s-las-sort-lock');
    body.style.position = 'fixed';
    body.style.top = '-' + scrollTop + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    locked = true;
  }

  function unlockScroll() {
    if (!locked) return;
    html.classList.remove('t4s-las-sort-lock');
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    window.scrollTo(0, scrollTop);
    locked = false;
  }

  function syncScrollLock() {
    if (isSortOpen()) {
      lockScroll();
    } else {
      unlockScroll();
    }
  }

  function syncSortVisibility() {
    if (!wrapper) return;

    if (isSortOpen()) {
      wrapper.style.setProperty('display', 'block', 'important');
      wrapper.style.setProperty('top', 'auto', 'important');
      wrapper.style.setProperty('bottom', '0', 'important');
      wrapper.style.setProperty('opacity', '1', 'important');
      wrapper.style.setProperty('visibility', 'visible', 'important');
      wrapper.style.setProperty('pointer-events', 'auto', 'important');
      wrapper.style.setProperty('transform', 'translateY(0)', 'important');
    } else {
      ['display', 'top', 'bottom', 'opacity', 'visibility', 'pointer-events', 'transform'].forEach(function(property) {
        wrapper.style.removeProperty(property);
      });
    }

    syncScrollLock();
  }

  function getHeaderNodes() {
    return Array.prototype.slice.call(document.querySelectorAll('.t4s-section-header, #shopify-section-header-bottom'));
  }

  function syncStickyTop() {
    stickyTopRaf = 0;
    collectionHeader = collectionHeader || document.querySelector('.t4s-collection-header');
    if (!collectionHeader) return;

    var visibleBottom = 0;
    getHeaderNodes().forEach(function(header) {
      var style = window.getComputedStyle(header);
      if (style.display == 'none' || style.visibility == 'hidden') return;

      var rect = header.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0 || rect.bottom <= 0 || rect.top > 1) return;
      visibleBottom = Math.max(visibleBottom, Math.min(rect.bottom, window.innerHeight));
    });

    collectionHeader.style.setProperty('--las-collection-sticky-top', Math.round(Math.max(0, visibleBottom)) + 'px');
  }

  function scheduleStickyTopSync() {
    if (!stickyTopRaf) {
      stickyTopRaf = window.requestAnimationFrame(syncStickyTop);
    }
    window.clearTimeout(stickyTopTimer);
    stickyTopTimer = window.setTimeout(function() {
      if (!stickyTopRaf) {
        stickyTopRaf = window.requestAnimationFrame(syncStickyTop);
      }
    }, 180);
  }

  function bindStickyTopSync() {
    collectionHeader = document.querySelector('.t4s-collection-header');
    if (!collectionHeader) return;

    scheduleStickyTopSync();
    if (headerObserversReady) return;

    getHeaderNodes().forEach(function(header) {
      header.addEventListener('transitionend', scheduleStickyTopSync);
      if (window.MutationObserver) {
        var observer = new MutationObserver(scheduleStickyTopSync);
        observer.observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
      }
    });

    headerObserversReady = true;
  }

  function bindSortWrapper() {
    wrapper = document.getElementById('t4s__sortby');
    if (wrapper && wrapper.parentElement !== body) {
      body.appendChild(wrapper);
    }

    if (!wrapper || wrapper.dataset.lasSortLockReady === 'true') {
      syncSortVisibility();
      return;
    }

    var observer = new MutationObserver(syncSortVisibility);
    observer.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
    wrapper.dataset.lasSortLockReady = 'true';
    syncSortVisibility();
  }

  function stopBackgroundScroll(event) {
    if (!isSortOpen()) return;
    if (event.target.closest && event.target.closest('#t4s__sortby')) return;
    event.preventDefault();
  }

  function getSortUrl(value) {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.set('sort_by', value);
    return url;
  }

  function handleSortItemClick(event) {
    var item = event.target.closest && event.target.closest('#t4s__sortby [data-sortby-item]');
    if (!item) return;

    var value = item.getAttribute('data-value');
    if (!value) return;

    var sortUrl = getSortUrl(value);
    if (sortUrl.href == window.location.href) return;

    event.preventDefault();
    event.stopPropagation();
    unlockScroll();
    window.location.assign(sortUrl.href);
  }

  document.addEventListener('DOMContentLoaded', function() {
    bindSortWrapper();
    bindStickyTopSync();
  });
  document.addEventListener('click', handleSortItemClick, true);
  document.addEventListener('click', function() {
    window.setTimeout(bindSortWrapper, 40);
    window.setTimeout(bindStickyTopSync, 40);
    window.setTimeout(syncSortVisibility, 80);
  }, true);
  document.addEventListener('touchmove', stopBackgroundScroll, { passive: false });
  document.addEventListener('wheel', stopBackgroundScroll, { passive: false });
  window.addEventListener('scroll', scheduleStickyTopSync, { passive: true });
  window.addEventListener('resize', syncSortVisibility);
  window.addEventListener('resize', scheduleStickyTopSync);
  bindSortWrapper();
  bindStickyTopSync();
})();

  } catch(e) { console.error(e); }
})();
})();
